const maintainOrderDetailPop = () => import('@/pages/maintainOrder/maintainOrderDetailPop')
const maintainOrder = () => import('@/pages/maintainOrder/index')
const maintainDetailList = () => import('@/pages/maintainOrder/maintainDetailList')
export default [{
  path: '/maintainOrderDetailPop',
  name: '/maintainOrderDetailPop',
  component: maintainOrderDetailPop,
  meta: {}
},
{
  path: '/maintainOrder',
  name: 'maintainOrder',
  component: maintainOrder,
  meta: {
    storeKey: 'trs.maintainOrder'
  }
},
{
  path: '/maintainDetailList',
  name: 'MaintainDetailList',
  component: maintainDetailList,
  meta: {
    cache: true
  }
}
]



// WEBPACK FOOTER //
// ./src/router/maintain/index.js